//Third party libraries

import NumericMetricWidget from '@/components/Widgets/NumericMetricWidget';

//Services
import { useDashboardData } from '../../../hooks/ReactQueryHooks/useDashboardQuery';
import type { DashboardType } from '../../../types/Analytics';
//Assets and miscellaneous
import { Widget } from '../constants';
//Custom components
import WidgetLayout from '../WidgetLayout';

const TotalProgramsWidget = ({ dashboard }: { dashboard: DashboardType }) => {
  const fetchTotalPrograms = useDashboardData({
    dashboard,
    widget: Widget.TOTAL_PROGRAMS,
  });

  const totalPrograms = fetchTotalPrograms?.data?.data?.length;
  return (
    <WidgetLayout dashboard={dashboard} widget={Widget.TOTAL_PROGRAMS} actionsBtnLocation='top-2 right-0'>
      <NumericMetricWidget title='Total Programs' value={totalPrograms ? totalPrograms : '0'} />
    </WidgetLayout>
  );
};

export default TotalProgramsWidget;
